export default "__VITE_ASSET__58e06387__"